export const STEPS_BEFORE_CRIF_CONTRIBUTION = [
  'Conferma dati aziendali',
  'Indica legale rappresentante',
  'Comunica titolari effettivi',
  'Richiedi importo'
] as const;
